import Vue from "vue";
import { ToastID } from "vue-toastification/dist/types/src/types";

export const toast = {
  info: (message: string) => Vue.$toast.info(message),
  error: (message: string) => Vue.$toast.error(message),

  /**
   * Shows a non-dismissing toast intended to be updated later via `toast.update`.
   */
  progress: (message: string): ToastID => Vue.$toast.info(message, { timeout: false }),

  /**
   * Updates a toast previously created via `toast.progress`.
   */
  update: (id: ToastID, options: { message: string; type: "success" | "error" | "info"; timeout?: number | false }) =>
    Vue.$toast.update(id, {
      content: options.message,
      options: { type: options.type, timeout: options.timeout ?? 4000 }
    })
};
